const LOCAL_STORAGE_WISHLIST_KEY = 'wishlist_products';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
    button: '[button-wishlist]',
    grid: '.js-wishlistBlock',
    productCard: '.product-card',
    countBubble: '.wishlist-count-bubble',
    countText: '.wishlist-count-text',
    headerButton: '.wishlist_button'
};

document.addEventListener('DOMContentLoaded', () => {
    initButtons();
    updateHeaderWishlistIcon();
    initGrid();

    // Watch for header changes (sticky header injection)
    const header = document.querySelector('header') || document.body;
    if (header) {
        const observer = new MutationObserver(() => {
            updateHeaderWishlistIcon();
        });
        observer.observe(header, { childList: true, subtree: true });
    }

    // Listen for updates from other sources (like product-card.js)
    window.addEventListener('wishlist:updated', () => {
        updateHeaderWishlistIcon();
    });
});

document.addEventListener('shopify:section:load', () => {
    initButtons();
    updateHeaderWishlistIcon();
});

function getWishlist() {
    // Try the new key first
    let wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);

    // If empty or null, try the legacy key
    if (!wishlist) {
        wishlist = localStorage.getItem('shopify_wishlist');
    }

    if (wishlist) {
        try {
            const parsed = JSON.parse(wishlist);
            // Handle array of objects (legacy) by mapping to handles if needed, 
            // OR just return valid items. The header count only needs .length.
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            console.error('Error parsing wishlist:', e);
            return [];
        }
    }
    return [];
}

function saveWishlist(wishlist) {
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, JSON.stringify(wishlist));
    // Dispatch a custom event so other parts of the app can react if needed
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist } }));
}

function toggleWishlist(handle) {
    const wishlist = getWishlist();
    const index = wishlist.indexOf(handle);
    let isAdded = false;

    if (index === -1) {
        wishlist.push(handle);
        isAdded = true;
        console.log('Added to wishlist:', handle);
    } else {
        wishlist.splice(index, 1);
        console.log('Removed from wishlist:', handle);
    }

    saveWishlist(wishlist);
    updateHeaderWishlistIcon();

    // Return status for UI updates
    return isAdded;
}

// Expose init function globally for debugging/manual trigger
window.initWishlist = function () {
    console.log('Wishlist: Manual init triggered');
    initButtons();
    updateHeaderWishlistIcon();
    initGrid();
};

function initButtons() {
    const buttons = document.querySelectorAll(selectors.button);
    console.log(`Wishlist: Found ${buttons.length} buttons to init`);
    buttons.forEach((button) => {
        setupButton(button);
    });
}

function setupButton(button) {
    const productHandle = button.dataset.productHandle;

    if (!productHandle) {
        console.warn('Wishlist: Button missing handle', button);
        return;
    }

    // Debug log to see if we are skipping
    if (button.dataset.wishlistInitialized === 'true') {
        // console.log('Wishlist: Skipping initialized button', productHandle);
        return;
    }

    console.log('Wishlist: Initializing button for', productHandle);
    button.dataset.wishlistInitialized = 'true';

    // Set initial state
    const wishlist = getWishlist();
    updateButtonState(button, wishlist.includes(productHandle));

    button.addEventListener('click', (e) => {
        console.log('Wishlist: Button clicked for', productHandle);
        try {
            e.preventDefault();
            e.stopPropagation();

            const isAdded = toggleWishlist(productHandle);
            updateButtonState(button, isAdded);

            // If we are on the wishlist page and removing an item, remove it from the grid
            if (!isAdded) {
                const grid = document.querySelector(selectors.grid);
                if (grid) {
                    removeProductFromGrid(productHandle);
                }
            }
        } catch (err) {
            console.error('Wishlist: Click handler failed', err);
        }
    });
}

function updateButtonState(button, isActive) {
    try {
        const svgPath = button.querySelector('path');
        if (isActive) {
            button.classList.add(BUTTON_ACTIVE_CLASS);
            if (svgPath) svgPath.style.fill = 'red';
        } else {
            button.classList.remove(BUTTON_ACTIVE_CLASS);
            if (svgPath) svgPath.style.fill = 'none';
        }
    } catch (e) {
        console.warn('Wishlist: Failed to update button state', e);
    }
}

function updateHeaderWishlistIcon() {
    try {
        const wishlist = getWishlist();
        const count = wishlist.length;

        const bubbles = document.querySelectorAll(selectors.countBubble);
        bubbles.forEach(bubble => {
            const text = bubble.querySelector(selectors.countText);
            // Only update if value changed to avoid MutationObserver loops
            if (text && text.textContent !== count.toString()) {
                text.textContent = count;
            }

            const isHidden = bubble.hasAttribute('hidden');
            if (count > 0 && isHidden) {
                bubble.removeAttribute('hidden');
            } else if (count === 0 && !isHidden) {
                bubble.setAttribute('hidden', true);
            }
        });

        // Use specific selector for header icon to avoid conflicts with product cards
        const headerButtons = document.querySelectorAll('.header__icon--wishlist');
        headerButtons.forEach(btn => {
            if (count > 0) {
                if (!btn.classList.contains('has-items')) btn.classList.add('has-items');
            } else {
                if (btn.classList.contains('has-items')) btn.classList.remove('has-items');
            }
        });
    } catch (e) {
        console.error('Wishlist: Failed to update header icon', e);
    }
}

function initGrid() {
    const grid = document.querySelector(selectors.grid);
    if (!grid) return;

    const wishlist = getWishlist();
    updateHeaderWishlistIcon();

    if (wishlist.length === 0) {
        showEmptyState(grid);
        grid.classList.add(GRID_LOADED_CLASS);
        return;
    }

    // Fetch all products
    const requests = wishlist.map(handle => fetchProductCard(handle));

    Promise.all(requests)
        .then(responses => {
            // Filter out any failed requests (empty strings)
            const validCards = responses.filter(html => html);

            if (validCards.length === 0) {
                showEmptyState(grid);
            } else {
                grid.innerHTML = validCards.join('');

                // Re-initialize buttons for the newly added cards
                const newButtons = grid.querySelectorAll(selectors.button);
                newButtons.forEach(btn => setupButton(btn));
            }

            grid.classList.add(GRID_LOADED_CLASS);
        });
}

function fetchProductCard(handle) {
    const productUrl = `/products/${handle}?section_id=wishlist-item`;

    return fetch(productUrl)
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.text();
        })
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Attempt to find the specific product card element
            // Adjust selectors based on your theme's markup
            const productCard = doc.querySelector('.card-wrapper') ||
                doc.querySelector('.card') ||
                doc.querySelector('.product-card');

            if (productCard) {
                // Wrap in a div to ensure our grid styling works and we have a handle hook
                return `<div class="wishlist-item" data-handle="${handle}">${productCard.outerHTML}</div>`;
            } else {
                // Fallback if specific card class isn't found, though this might include garbage
                return `<div class="wishlist-item" data-handle="${handle}">${doc.body.innerHTML}</div>`;
            }
        })
        .catch(err => {
            console.error(`Failed to load product ${handle}`, err);
            // If a product doesn't exist anymore (404), maybe we should remove it from wishlist?
            // For now, just return empty string so it doesn't break the grid
            return '';
        });
}

function removeProductFromGrid(handle) {
    const grid = document.querySelector(selectors.grid);
    if (!grid) return;

    const item = grid.querySelector(`.wishlist-item[data-handle="${handle}"]`);
    if (item) {
        // Add a fade-out effect
        item.style.transition = 'opacity 0.3s ease, visibility 0.3s ease';
        item.style.opacity = '0';
        item.style.visibility = 'hidden';

        setTimeout(() => {
            item.remove();

            // Check if grid is now empty
            const wishlist = getWishlist();
            if (wishlist.length === 0) {
                showEmptyState(grid);
            }
        }, 300); // Wait for transition
    }
}

function showEmptyState(grid) {
    grid.innerHTML = '<p class="wishlist-empty text-center">Your wishlist is currently empty.</p>';
}
